module.exports = __webpack_public_path__ + "static/about-the-program-body-c6f5c4ada120a2cccc1ef21fbc0ffc6b.jpg";